/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBubbleMessage: {
  name: 'bubble-message';
  data: string;
} = {
  name: 'bubble-message',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a2 2 0 0 0-2 2v16a1 1 0 0 0 1.514.858L8.277 19H20a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm0 2h16v12H8.277a2 2 0 0 0-1.029.285L4 19.234V5Zm12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
